// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".successBody___GsFIH{font-size:16px;display:inline-block;line-height:24px}\n", "",{"version":3,"sources":["webpack://./src/routes/Overrides/components/AddMerchantModal/AddMerchantModal.css"],"names":[],"mappings":"AAAA,qBACI,cAAA,CACA,oBAAA,CACA,gBAAA","sourcesContent":[".successBody {\n    font-size: 16px;\n    display: inline-block;\n    line-height: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successBody": "successBody___GsFIH"
};
export default ___CSS_LOADER_EXPORT___;
